export default {
  /**
   *
   * @param {*} item
   */
  getSlicedDescription (item) {
    return this.getSlicedText(item, 160)
  },

  /**
   *
   * @param {*} item
   */
  getSlicedTitle (item) {
    return this.getSlicedText(item, 70)
  },

  /**
   *
   * @param {*} item
   */
  getSlicedText (item, maxSize) {
    if (item && item.length > maxSize) {
      return item.slice(0, maxSize - 3).replace(/\n|\r|(\n\r)/, '') + '...'
    } else {
      return item
    }
  }
}
